module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_8004.9ac8d493.png";